module.exports = __webpack_public_path__ + "img/page1-ico1.be6f2fb7.png";